import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introduction() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/alhussaini/tek-img_01.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={653}
              height={381}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2>The Idea Behind Al Hussaini Trading Co.</h2>
            <p>
              We were responsible for refining the eCommerce presence of Al
              Hussaini Trading Company by evaluating their digital presence and
              presenting a full-fledged alternative from scratch that comprised
              of building a more connected omnichannel interface.
            </p>
            <p>
              The idea of an omnichannel eCommerce solution is to provide
              customers with a unified experience across different channels –
              whether it be phone, desktop, or a visit to one of the 40+ Al
              Hussaini Trading Company outlets across the Kingdom
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introduction;
